import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { BadgeColor, BadgeSize } from '../../enums';
import styles from './Badge.module.scss';
const Badge = ({ children, className, color = BadgeColor.Brand, isRounded, size = BadgeSize.Big, ...restProps }) => {
    return (_jsx("span", { className: classnames('d-inline-flex justify-content-center align-items-center fw-semibold', styles.badge, styles[color], styles[size], { [styles.isRounded]: isRounded }, className), ...restProps, children: children }));
};
export { Badge };
